module.exports = __webpack_public_path__ + "static/media/face5.8f0bd643.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/face5.svg
// module id = 975
// module chunks = 0